// extracted by mini-css-extract-plugin
export default {"header":"style_header__JYHyn","previousIcon":"style_previousIcon__fTC9J","heading":"style_heading__LhgOH"};